import { UpdateSettingsProps } from '~/definitions/generalSettings';
import { getStore } from '~/mobx/AppStore';

const updateElectionAttributeData = async (assignedItems?: UpdateSettingsProps[]) => {
    const { generalSettingsStore } = getStore();
    const { companyElectionData = [], selectedElectionData, selectedElectionId, electionList } = generalSettingsStore;
    const { attributes = [] } = selectedElectionData;

    const updatedAttributes = attributes?.map((attr) => {
        const update = companyElectionData?.find((data) => data.id === attr.id);
        const updateValue = update?.value || '';
        const assign = assignedItems?.find((data) => data.id === attr.id);
        let updated = { ...attr };
        if (update) {
            updated = { ...updated, value: updateValue };
        }
        if (assign) {
            updated = { ...updated, isAttributeAssigned: true };
        }
        return updated;
    });

    const updateSelectedElectionData = { ...selectedElectionData, attributes: [...updatedAttributes] };
    const updateElectionList = electionList?.map((election) => {
        if (election.id === selectedElectionId) {
            return { ...election, attributes: [...updatedAttributes] };
        }
        return election;
    });

    generalSettingsStore.setElectionList([...updateElectionList]);
    generalSettingsStore.setSelectedElectionData({ ...updateSelectedElectionData });
};

export default updateElectionAttributeData;
